export const VERIFICATION_TASK_STATUSES: string[] = [
  'APPROVED_BY_LENDER',
  'APPLICATION_AT_AUTOPAY',
  'APPLICATION_AT_LENDER',
  'APPLICATION_COMPLETE',
  'APPLICATION_COMPLETE_PORTAL',
  'ARCHIVE',
  'AT_LENDER_FOR_FUNDING',
  'AT_LENDER_FUNDING_PENDING',
  'CONTRACT_REQUESTED',
  'DEAL_RETURNED_BY_LENDER',
  'DOCS_AT_STATE',
  'DOCS_WITH_CUSTOMER',
  'EDOCS_SIGNED',
  'EDOCS_SIGNED_TRACKING',
  'FUNDING_DELAYED',
  'FUNDING_HOLD',
  'QA',
  'QA_HOLD',
  'RECONTRACTING',
  'RETURNED_BY_CONTRACTING',
  'RETURNED_BY_QA',
  'RETURN_FROM_UW',
  'TITLE_PERFECTED',
  'UW_PROCESSING',
];
